import type { LogRecord } from '@logtape/logtape'
import { configure, getConsoleSink, getLogger } from '@logtape/logtape'
import { useAuthStore } from '@/stores/auth'
import { API_BASE_URL } from './env'

// --- サーバーバッチ送信 Sink ---
const FLUSH_INTERVAL_MS = 1_000

interface BufferedLog {
  level: string
  message: string
  category: string[]
}

function getServerBatchSink() {
  let buffer: BufferedLog[] = []

  function flush(): void {
    if (buffer.length === 0) return
    const token = useAuthStore.getState().getToken()
    if (!token) {
      buffer = []
      return
    }
    const logs = buffer
    buffer = []
    fetch(`${API_BASE_URL}/api/client-log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ logs }),
    }).catch(() => {})
  }

  setInterval(flush, FLUSH_INTERVAL_MS)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush()
  })

  return (record: LogRecord): void => {
    const message = record.message.map(String).join('')
    buffer.push({
      level: record.level,
      message,
      category: [...record.category],
    })
  }
}

/**
 * LogTape を初期化する
 *
 * アプリケーション起動時に一度だけ呼び出す。
 * ブラウザコンソール・サーバー送信ともに全レベル出力。
 * ログレベルのフィルタはバックエンド側の LOG_LEVEL で一元管理する。
 *
 * @see docs/logging.md
 */
export async function setupLogger(): Promise<void> {
  await configure({
    sinks: {
      console: getConsoleSink(),
      server: getServerBatchSink(),
    },
    loggers: [
      {
        category: ['app'],
        lowestLevel: 'trace',
        sinks: ['console', 'server'],
      },
    ],
  })
}

/** ユーザー操作トレースのロガー。subcategory で画面・コンポーネントを指定 */
export function getUiLogger(...subcategories: string[]) {
  return getLogger(['app', 'ui', ...subcategories])
}
